import { Id } from "@dgs/core";
import { CountryIndexResource } from "../../../../shared/types/country";

export const ALL_ADDRESS = ["private", "work", "other"] as const;

export type AddressType = (typeof ALL_ADDRESS)[number];

export type AddressIndexResource = {
	id: Id;
	city: string;
	zip: string;
	houseNumber: string;
	street: string;
	type: AddressType;
	isPrimary: boolean;
	country: CountryIndexResource;
	additionalInfo: string | null;
};

export type AddressUpdateResource = AddressIndexResource;

export type AddressFormState = Omit<AddressUpdateResource, "id" | "country"> & {
	country: CountryIndexResource | null;
};

export type AddressSaveRequest = Omit<AddressUpdateResource, "id" | "country"> & {
	countryId: Id | null;
};
